import PageProtected2Col from '../../components/Page/PageProtected2Col';
import { Grid, Typography, Card, CardContent, Box, Divider, Stack } from '@mui/material';
import BloodtypeIcon from '@mui/icons-material/Bloodtype';
import ScienceIcon from '@mui/icons-material/Science';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { julia } from '../../constants';

import DiaGetLabs from './OrderTestsAux/DiaGetLabs';
import ButtonsTextGoTo from '../../components/Button/ButtonTextGo';


export default function OrderTests() {

    return (

        
    <PageProtected2Col

      leftsideimage={julia}
      brandtext="Preventive Health Intelligence"
      headline=""
      formcomp={<>


 <Grid container spacing={2}>
      <Grid size={12}>
        <Card elevation= {10} variant="outlined"
      
            sx={{
                
                bgcolor: 'background.paper',
                borderRadius: "12px",  
                boxShadow: '0 10px 10px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                transformStyle: 'preserve-3d',
                '&:hover': {
                transform: 'scale(1.01)',
                },
                maxWidth: 500,
                margin: 'auto',
                padding: 4

            }}>  

            <CardContent sx={{display: 'grid', placeItems: 'center', textAlign: 'center' }}>

              {/* Title */}
                <Box display="flex" alignItems="center" gap={1} sx={{ mb: 2}}>
                <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
                      Payment Canceled!
                </Typography>
                </Box>

                {/* Features with icons */}
                <Stack spacing={2} alignItems="center" sx={{ mb: 3 }}>
                    
                    <Box display="flex" alignItems="center" gap={1} sx={{}}>
                        <Typography variant="h6">Your payment was not completed. Please try again or contact support.</Typography>
                    </Box>
                    <Box display="flex" alignItems="center">
                        <Typography variant="h6">Please try again or contact support</Typography>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                       <DiaGetLabs />
                    </Box>
                    <Box display="flex" alignItems="center" >
                        <Typography variant="h6">Your test results will be available<br /> usually 1 - 4 days after your lab visit.</Typography>
                    </Box>
                
                </Stack>

                <Divider sx={{ width: '100%', mt: 2, mb:4 }} />

                {/* Extra info */}
                <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
                Please try again.
                </Typography>

                <Box sx={{mt:2}}>
                    <ButtonsTextGoTo to="/Login" name="Sign In" color="primary.main"/>
              </Box>

            </CardContent> 
       </Card>  
      </Grid>
   </Grid>
  </>}
/>

  )
}
